function changeDaySelected(day, old, days) {
    const oldDay = {
        ...days[old],
        selected: false,
    };

    const newDay = {
        ...days[day],
        selected: true,
    };

    return {
        ...days,
        [old]: { ...oldDay },
        [day]: { ...newDay },
    };
}

export default changeDaySelected;
